<template>
    <v-row align="center">
    
        <v-col cols="9">
    
            <v-file-input multiple :label="label" ref="myfile" v-model="files" prepend-icon="mdi-camera" @change="submitFiles"></v-file-input>
            
        </v-col>
        <v-col v-if="files.length >0 || (value && value.filename)" cols="1" align="center" justify="center">
  
            <!--
                <v-btn v-if="!uploading " color="primary" text @click="submitFiles">{{(uploaded || (value && value.filename) ) ?'carica nuovo':'carica'}}</v-btn>
            -->
            <img :src ="value.url" height="50px"/>
            <v-progress-circular
            v-if="uploading" 
            indeterminate
            color="primary"
            ></v-progress-circular>

        </v-col>
    
    </v-row>
</template>
<script>
import firebase from 'firebase';

export default {
    props: ["label","filename","value"],
    data() {
        return {
            uploading : false,
            uploaded : false,
            files: []
        }
    },
    watch: {

    },
    methods: {
        submitFiles() {
            if (this.files) {

            this.uploading = true
            var storageRef = firebase.storage().ref();
            //var imagesRef = storageRef.child('images');
            const me = this;
            for (let file of this.files) {
                var spaceRef = storageRef.child('images/'+this.filename+'/'+file.name);
                   spaceRef.put(file).then(function(snapshot) {
                    console.log('Uploaded a blob or file!',file,snapshot);
                    me.uploading = false;
                    me.uploaded= true;
                    snapshot.ref.getDownloadURL().then(function(downloadURL) {
                    console.log('File available at', downloadURL,file);
                    me.$emit("input",{url:downloadURL,filename:file.name})
                    });

                });
            }
/*
                let formData = new FormData();
                this.uploading = true

                // files
                console.log(this.files)

                for (let file of this.files) {
                    formData.append("files", file, file.name);
                    console.log(formData)
                    let url = 'https://firebasestorage.googleapis.com/v0/b/precheckin-1466b.appspot.com/o?uploadType=media&name=' + this.filename
                    this.$http.post(url, formData).then(response => {
                            console.log("Success!");
                            console.log({ response });
                            this.uploading = false
                            this.uploaded = true
                        })
                        .catch(error => {
                            console.log({ error });
                            this.uploading = false
                            this.uploaded = false
                        });
                }

*/


            } else {
                console.log("there are no files.");
            }
        }
    }
}
</script>